/*eslint-disable array-callback-return */
/*eslint-disable linebreak-style */
/*eslint-disable eqeqeq */
/*eslint-disable no-redeclare */
/*eslint-disable no-unused-vars */
import React, { useEffect } from 'react';
import { useTable, useSortBy, usePagination } from 'react-table';
import '../details/claimdetails';
import { Link, Navigate } from 'react-router-dom';
import CustomClientError from 'src/Admin/errorhandling/CustomClientError';

const ClaimsDocumentsTable = ({
  columns,
  data,
  setPageSizeLocal,
  setPageCount,
  pageSizeLocal,
  pageCount,
  totalRecords,
}) => {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    footerGroups,
    page,
    prepareRow,
    setPageSize,
    //pageCount,
    //state: { pageSize },
  } = useTable(
    {
      columns,
      data,
      disableSortRemove: true,
      initialState: {
        pageIndex: 0,
        pageSize: pageSizeLocal,
      },
    },
    useSortBy,
    usePagination,
  );
  const onClick = (ele) => {
    if (ele) {
      console.log(ele, 'download files');
      /*Navigate('/admin/view-documents', {
  state: null,
  });*/
    }
  };

  useEffect(() => {
    setPageSize(pageSizeLocal);
  }, [pageSizeLocal]);

  console.log('pageCount===', page, data, pageSizeLocal, totalRecords);

  return (
    <>
      <table {...getTableProps()} aria-rowcount={data?.length}>
        {data?.length > 0 && (
          <>
            <thead>
              {headerGroups.map((headerGroup, index) => (
                <tr key={index} {...headerGroup.getHeaderGroupProps()}>
                  {headerGroup.headers.map((column) => {
                    return (
                      <th
                        key={index}
                        {...column.getHeaderProps(
                          column.getSortByToggleProps({ title: undefined }),
                        )}
                        scope="col"
                        role="columnheader"
                        onKeyPress={(event) => {
                          if (
                            column.sortable !== false &&
                            event.key === 'Enter'
                          ) {
                            column.toggleSortBy();
                          }
                        }}
                        className={
                          column.isSorted
                            ? 'coloumnIsSorted'
                            : 'coloumnNotSorted'
                        }
                      >
                        <b>{column.render('Header')}</b>
                        <span
                          className={
                            column.isSorted
                              ? column.isSortedDesc
                                ? 'arrowDown'
                                : 'arrowUp'
                              : 'arrowNormal'
                          }
                        ></span>
                      </th>
                    );
                  })}
                </tr>
              ))}
            </thead>
            <tbody {...getTableBodyProps()}>
              {page.map((row, index) => {
                prepareRow(row);
                return (
                  <tr key={index} {...row.getRowProps()}>
                    {row.cells.map((cell, index) => {
                      return (
                        <td
                          key={index}
                          {...cell.getCellProps()}
                          role="cell"
                          //onClick={() => (index === 3 ? onClick(row) : null)}
                        >
                          {index === 3 ? (
                            <p className="claims-document-data">
                              <p>{cell.render('Cell')}</p>
                            </p>
                          ) : (
                            <p>{cell.render('Cell')}</p>
                          )}
                          {/*<p>{cell.render('Cell')}</p> */}
                        </td>
                      );
                    })}
                  </tr>
                );
              })}
            </tbody>
          </>
        )}
      </table>
      {pageSizeLocal < totalRecords?.length && (
        <button
          id="showmore"
          className="show-more-claims-document-button"
          onClick={() => {
            setPageCount((prev) => prev + 1);
            //setPageSize((pageCount + 1) * pageSize);
            console.log('page size: ', pageCount * pageSizeLocal);
            //document.getElementById('showmore').style.visibility = 'hidden';
          }}
        >
          SHOW MORE...
        </button>
      )}
      {data?.length == 0 && (
        <div className="document-no-data text-center">
          <CustomClientError
            CustomClasses="p-0 m-0"
            ErrorHeading="No Documents found!"
            ErrorMessage="We could not find any documents for the selected claims"
          />
        </div>
      )}
    </>
  );
};

export default ClaimsDocumentsTable;
